import { AppStorageKeys, PayxpressAPIResponse } from "@/models";
import { AppStorage } from "@/store";
import { fetchBaseQuery } from "@reduxjs/toolkit/query";

export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
type BaseQueryType = ReturnType<typeof fetchBaseQuery>;

export const baseQueryWithReauth: (baseQuery: BaseQueryType) => BaseQueryType =
  (baseQuery) => async (args: any, api: any, extraOptions: any) => {
    let result = (await baseQuery(args, api, extraOptions)) as any;
    if (result.error && result.error.status === 401) {
      window.location.href = "/";
      sessionStorage.clear();
    }
    return result;
  };

export const baseQuery = fetchBaseQuery({
  baseUrl: API_BASE_URL,
  prepareHeaders: (headers) => {
    const user = <PayxpressAPIResponse.UserInfo>(
      AppStorage.getItem(AppStorageKeys.User)
    );
    if (user?.token?.jwtToken)
      headers.set("Authorization", `bearer ${user?.token?.jwtToken}`);
    return headers;
  },
});

export const endpoints = {
  Auth: {
    Login: "Auth/v2/login",
    RefreshToken: "Auth/refresh-token",
    GenerateOTP: (email: string, phoneNumber: string) =>
      `Auth/generate-otp/${email}/${phoneNumber}`,
    VerifyOTP: "Auth/verify-otp",
    Register: "Auth/register",
    ForgotPassword: (email: string) => `Auth/forgot-password/${email}`,
    CreatePassword: "Auth/forgot-password",
    VerifyBVN: `Auth/verify-bvn/`,
    ChangePassword: "Users/change-password",
    VerifyTagName: "Auth/verify-tagname/",
  },
  Wallet: {
    Details: "Wallet/get-wallet-details",
    VerifyPinOTP: "Auth/verify-pin-otp",
    ResetPin: "Auth/reset-pin-otp",
    ChangePassword: "Users/change-password",
    ChangePin: "Wallet/changepin",
    GeneratePinOTP: "Auth/generate-pin-otp",
    CreatePin: "Wallet/createPin",
    Statement: "Wallet/Statement?",
    GetTodayStatement: "Wallet/getstatement",
    Transfer: "Wallet/Transfer",
  },
  Transaction: {
    Statement: "Billers/Dashboard/TransactionHistory",
    AllHistory: "Billers/Dashboard/AllTransactionHistory",
  },
  Billers: {
    GetCategories: "Billers/get-all-Categories",
    SubCategories: "Billers/get-subcategories",
    GetProductByBiller: "Billers/get-product-by-billerid",
    Purchase: "Billers/purchase",
    VerifyPayment: "Billers/Verify/",
    ElectrictyLookup: "Billers/electricity-account-lookup",
    CableLookup: "Billers/cabletv-account-lookup",
    WaecLookup: "Billers/waec-registration-account-lookup",
    JambLookup: "Billers/jamb-account-lookup",
    BettingLookup: "Billers/betting-account-lookup",
    DataLookup: "Billers/data-account-lookup",
  },
  Recurring: {
    Create: "Recurring/create",
    Stop: "Recurring/stop",
    Restart: "Recurring/restart",
    GetRecurringTransactions: "Recurring/GetRecurringTransactions?",
    GetUpcomingRecurring: "Recurring/Dashboard/Upcoming",
  },
  Referrals: {
    GetReferrals: "Referral/program/get-by-user",
  },
};
